import { memo } from 'react';
import { motion } from 'motion/react';

import { useGetParams } from '../../hooks/useGetParams';

import styles from './Advt.module.css';

const Advt = memo(() => {
  const { title, qrCode1, qrCode2, paddingQR, sizeQR, titleFontSize } =
    useGetParams();

  const advtlines = title.split(/\\n/);

  return (
    <div className={styles.wrapper}>
      {advtlines && (
        <div>
          {advtlines.map((line, idx) => (
            <motion.div
              key={line + idx}
              initial={{ opacity: 0, x: idx % 2 ? '100vw' : '-100vw' }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.65 }}
              className={styles.title}
              style={{ fontSize: `${titleFontSize}rem` }}
            >
              <div>{line}</div>
            </motion.div>
          ))}
        </div>
      )}

      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              opacity: { duration: 0.5 },
              scale: { duration: 0.65 },
            }}
            className={styles.qrCode}
            style={{
              padding: `${paddingQR}rem`,
              background: paddingQR === '0' && 'none',
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode1} alt="qrCode1" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              opacity: { duration: 0.5, delay: 0.25 },
              scale: { duration: 0.65, delay: 0.25 },
            }}
            className={styles.qrCode}
            style={{
              padding: `${paddingQR}rem`,
              background: paddingQR === '0' && 'none',
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode2} alt="qrCode2" />
          </motion.div>
        )}
      </div>
    </div>
  );
});

export default Advt;
